import { UpdateWccDto, WccDto } from '@sr/dto';
import { useState, useEffect } from 'react';
import { fetchInvoiceWcc, postInvoiceWcc, deleteInvoiceWcc, fetchUpdateWcc, fetchWcc } from './api';
import { useSnack } from 'shared/ui/snack';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';

type Props = {
  invoiceId?: number;
  wccId?: number;
  initialWcc: WccDto | null;
};
/**
 * TODO: this should be rewritten to RTK
 * @param invoiceId  номер счета
 * @param initialWcc начальное значение актов (например из счета)
 */
export const useInvoiceWcc = ({ invoiceId, wccId, initialWcc }: Props) => {
  const [wcc, setWcc] = useState<WccDto | null>(initialWcc);

  const [isFetchingWcc, setFetchingWcc] = useState(false);
  const [isPostingWcc, setPostingWcc] = useState(false);

  const { showError } = useSnack();

  useEffect(() => {
    if (initialWcc) {
      setWcc(initialWcc);
      return;
    }

    const fetchData = async () => {
      try {
        setFetchingWcc(true);

        if (invoiceId) {
          const invoiceWcc = await fetchInvoiceWcc(invoiceId);
          setWcc(invoiceWcc.wcc);
        }

        if (wccId) {
          const fetchedWcc = await fetchWcc(wccId);
          setWcc(fetchedWcc);
        }
      } catch (e) {
        showError(extractNestJsErrorMessage(e));
      } finally {
        setFetchingWcc(false);
      }
    };

    fetchData();
  }, [invoiceId, wccId, initialWcc]);

  const createWcc = async () => {
    if (!invoiceId) throw new Error('Invoice ID is required');
    setPostingWcc(true);
    return postInvoiceWcc({ invoiceId })
      .then((result) => {
        setWcc(result.wcc);
      })
      .finally(() => setPostingWcc(false));
  };

  const deleteWcc = async () => {
    if (!invoiceId) throw new Error('Invoice ID is required');
    setPostingWcc(true);
    return deleteInvoiceWcc(invoiceId)
      .then(() => {
        setWcc(null);
      })
      .catch((e) => showError(extractNestJsErrorMessage(e)))
      .finally(() => setPostingWcc(false));
  };

  const updateWcc = async (dto: UpdateWccDto) => {
    setPostingWcc(true);
    return fetchUpdateWcc(dto)
      .then((res) => {
        setWcc({ ...res });
      })
      .catch((e) => showError(extractNestJsErrorMessage(e)))
      .finally(() => setPostingWcc(false));
  };

  return {
    invoiceWcc: wcc,
    setInvoiceWcc: setWcc,
    createWcc,
    updateWcc,
    deleteWcc,
    isFetchingWcc,
    isPostingWcc,
  };
};
